import { Box } from '~/commonComponents';
import { Tab, TabList, Tabs } from '~/commonComponents/Tabs';
import { JobPostingStatus, JobPostingStatusMapper } from '~/domain/PermanentJobs';

interface IJobPostingStatusFilterPanelProps {
  counts: Record<JobPostingStatus, number>;
  onChange(tab: JobPostingStatus): void;
}

export const JobPostingStatusFilterPanel = ({
  counts,
  onChange,
}: IJobPostingStatusFilterPanelProps) => {
  const tabs = [
    {
      title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Active),
      value: JobPostingStatus.Active,
    },
    {
      title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Closed),
      value: JobPostingStatus.Closed,
    },
    {
      title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Suspended),
      value: JobPostingStatus.Suspended,
    },
    {
      title: `${JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Draft)}s`,
      value: JobPostingStatus.Draft,
    },
  ].filter((it) => {
    if (it.value === JobPostingStatus.Suspended && counts.suspended === 0) {
      return false;
    }

    return true;
  });

  const handleTabChange = (idx: number) => {
    onChange(tabs[idx].value);
  };

  return (
    // @ts-expect-error JS Component
    <Tabs tabListStyle={{ gap: 16 }} onChangeTab={handleTabChange}>
      {/* @ts-expect-error JS Component */}
      <TabList>
        {tabs.map((it) => (
          <Tab
            PrefixComponent={
              <Box
                backgroundColor={JobPostingStatusMapper.getColor(it.value)}
                borderRadius="100%"
                height={10}
                width={10}
              />
            }
            key={it.value}
            title={`${it.title}${counts[it.value] > 0 ? ` (${counts[it.value]})` : ''}`}
            textStyle={{
              fontSize: 20,
            }}
          />
        ))}
      </TabList>
    </Tabs>
  );
};
